import React from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Fade,
} from '@mui/material';
import {
  Business as BusinessIcon,
} from '@mui/icons-material';

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'primary.main',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Fade in timeout={500}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {/* Logo/Icon */}
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              bgcolor: 'action.hover',
              backdropFilter: 'blur(10px)',
              border: '2px solid',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
              animation: 'pulse 2s ease-in-out infinite',
              '@keyframes pulse': {
                '0%': {
                  transform: 'scale(1)',
                  boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.4)',
                },
                '70%': {
                  transform: 'scale(1.05)',
                  boxShadow: '0 0 0 10px rgba(255, 255, 255, 0)',
                },
                '100%': {
                  transform: 'scale(1)',
                  boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)',
                },
              },
            }}
          >
            <BusinessIcon 
              sx={{ 
                fontSize: 40, 
                color: 'primary.contrastText',
                animation: 'rotate 2s linear infinite',
                '@keyframes rotate': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' },
                },
              }} 
            />
          </Box>

          {/* Loading Spinner */}
          <Box sx={{ position: 'relative' }}>
            <CircularProgress
              size={60}
              thickness={4}
              sx={{
                color: 'primary.contrastText',
                opacity: 0.9,
                animation: 'spin 1s linear infinite',
                '@keyframes spin': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' },
                },
              }}
            />
            <CircularProgress
              size={60}
              thickness={4}
              variant="determinate"
              value={75}
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                color: 'action.disabled',
                transform: 'rotate(180deg)',
              }}
            />
          </Box>

          {/* Loading Text */}
          <Typography
            variant="h5"
            sx={{
              color: 'primary.contrastText',
              fontWeight: 600,
              textAlign: 'center',
              mb: 1,
            }}
          >
            WebCard Digital
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'primary.contrastText',
              textAlign: 'center',
              opacity: 0.9,
              fontSize: '16px',
              fontWeight: 400,
            }}
          >
            Loading your digital business cards...
          </Typography>

          {/* Animated Dots */}
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              mt: 2,
            }}
          >
            {[0, 1, 2].map((index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: 'primary.contrastText',
                  animation: `bounce 1.4s ease-in-out ${index * 0.2}s infinite`,
                  '@keyframes bounce': {
                    '0%, 80%, 100%': {
                      transform: 'scale(0.8)',
                      opacity: 0.5,
                    },
                    '40%': {
                      transform: 'scale(1.2)',
                      opacity: 1,
                    },
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default LoadingScreen;



